// extracted by mini-css-extract-plugin
export var container = "_5x-1";
export var cornerButtonContainer = "_5x-6";
export var disabled = "_5x-2";
export var dragActive = "_5x-3";
export var fileContainer = "_5x-5";
export var hiddenInput = "_5x-4";
export var widthContainer = "_5x-0";